// frontend/src/api/valuationDisclaimer.ts
//
// VAL-PAY-FLOW-1 (was VAL-TERMS-ACCEPT-1) — the owner's acceptance of the
// Valuation ESTIMATE DISCLAIMER, taken before the pay screen
// (apps/api/routers/_valuation_disclaimer.py). Not the platform Terms of
// Service: that is TosGate. The server holds the text, its version and its
// hash; this file only fetches and records.

import { apiClient } from '@/api/client'

const eng = (id: string) => `/v1/valuation/engagements/${id}`

export interface ValuationDisclaimer {
  valuation_engagement_id: string
  version: string
  title: string
  notice: string
  checkbox_label: string
  button_label: string
  text_sha256: string
  /** False for staff (signer, super_admin): they are not gated. */
  required: boolean
  accepted: boolean
  accepted_at: string | null
}

export async function fetchValuationDisclaimer(id: string): Promise<ValuationDisclaimer> {
  const { data } = await apiClient.get<ValuationDisclaimer>(`${eng(id)}/disclaimer`)
  return data
}

/** Records the affirmative act: the box was ticked AND the button clicked. */
export async function acceptValuationDisclaimer(
  id: string, disclaimer: ValuationDisclaimer,
): Promise<ValuationDisclaimer> {
  const { data } = await apiClient.post<ValuationDisclaimer>(`${eng(id)}/disclaimer/accept`, {
    accepted: true,
    disclaimer_version: disclaimer.version,
    text_sha256: disclaimer.text_sha256,
  })
  return data
}

/** The server refused (pay screen, checkout, value or report): the current disclaimer is not accepted. */
export function isDisclaimerRequiredError(err: unknown): boolean {
  const details = (err as { response?: { data?: { error?: { details?: { disclaimer_required?: unknown } } } } })
    ?.response?.data?.error?.details
  return details?.disclaimer_required === true
}
